// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASEURL:"https://cygnus.maiorders.com/admin/FoodDeliverySystem/api_single_res/",
  BASEURL_RES_IMGS:window.location.origin+"/admin/FoodDeliverySystem/uploads/restaurant/",
  BASEURL_DEAL_IMGS:window.location.origin+"/admin/FoodDeliverySystem/uploads/deals/",

  BASEURL_SUBMENU_IMGS:window.location.origin+"/admin/FoodDeliverySystem/uploads/menu_images/",
  
  ROOT_BASEURL:"https://cygnus.maiorders.com/"

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
